import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';
import { ValuationTypeResources } from 'services/resources/catalogs/valuation-type';

export const ValuationTypePage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(ValuationTypeResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.valuation-type.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
